export enum UwDecisionReasons {
  alcohol_use = 'alcohol use',
  aviation = 'aviation',
  avocations = 'avocations',
  build = 'stated build',
  cardiovascular = 'cardiovascular condition',
  cholesterol = 'history of cholesterol',
  partner_coverage = "partner's coverage",
  criminal_record = 'criminal record',
  disability = 'disability',
  disability_migranes = 'disability',
  driving_record = 'driving record',
  product_unsupported = 'product eligibility',
  endocrine = 'endocrine condition',
  ent = 'ear, nose, and throat',
  existing_coverage = 'existing coverage',
  fam_health_hist = 'family health history',
  financials = 'financial eligibility',
  foreign_travel = 'foreign travel',
  gastrointestional = 'gastrointestional condition',
  genitourinary = 'genitourinary condition',
  hematology_anemia = 'blood disorder',
  hist_of_cancer = 'history of cancer',
  inf_obtained_3rdParty = 'third party data',
  inf_obtained_labs = 'data obtained during labs',
  inf_obtained_MIB = 'MIB record',
  inf_obtained_mvr = 'third party motor vehicle data',
  inf_obtained_rx = 'third party prescription data',
  int_review_flag = 'manual underwriter review required',
  m3s = 'm3s decision',
  mu_exists = 'previously manually underwritten',
  musculoskeletal = 'musculoskeletal condition',
  neurological = 'neurological condition',
  occupation = 'occupation',
  oncology = 'oncology condition',
  other_medical = 'other medical history',
  owner = 'owner information required',
  pregnancy = 'pregnancy',
  prev_app_activity = 'a previous application',
  psychiatric = 'psychiatric condition',
  pulmonary = 'pulmonary condition',
  reproductive = 'reproductive condition',
  rheumatological = 'rheumatological condition',
  skin = 'skin condition',
  special_handling = 'special handling required',
  substance_abuse = 'substance abuse',
  tobacco = 'tobacco use',
  waiver_unsupported = 'waiver eligibility',
}
